export interface CurrencyDefinition {
  code: string;
  name: string;
  symbol: string;
  country: string;
  flag: string;
  decimalDigits: number;
}

export type CurrencyOption = CurrencyDefinition;

export interface CurrencyFieldValue {
  currencyType: string;
  amount: number | null;
}

export interface CurrencyFieldConfig {
  label: string;
  description: string;
  placeholder: string;
  defaultCurrency: string | null;
  allowedCurrencies: readonly CurrencyOption[];
  decimalPrecision: number | null;
  required: boolean;
  allowChangeCurrency: boolean;
  disabled: boolean;
  readonly: boolean;
  min: number | null;
  max: number | null;
}

export const CURRENCY_DEFINITIONS: readonly CurrencyDefinition[] = [
  { code: 'USD', name: 'United States Dollar', symbol: '$', country: 'US', flag: '🇺🇸', decimalDigits: 2 },
  { code: 'INR', name: 'Indian Rupee', symbol: '₹', country: 'IN', flag: '🇮🇳', decimalDigits: 2 },
  { code: 'EUR', name: 'Euro', symbol: '€', country: 'EU', flag: '🇪🇺', decimalDigits: 2 },
  { code: 'GBP', name: 'British Pound', symbol: '£', country: 'GB', flag: '🇬🇧', decimalDigits: 2 },
  { code: 'AED', name: 'UAE Dirham', symbol: 'د.إ', country: 'AE', flag: '🇦🇪', decimalDigits: 2 },
  { code: 'SAR', name: 'Saudi Riyal', symbol: '﷼', country: 'SA', flag: '🇸🇦', decimalDigits: 2 },
  { code: 'CAD', name: 'Canadian Dollar', symbol: 'C$', country: 'CA', flag: '🇨🇦', decimalDigits: 2 },
  { code: 'AUD', name: 'Australian Dollar', symbol: 'A$', country: 'AU', flag: '🇦🇺', decimalDigits: 2 },
  { code: 'SGD', name: 'Singapore Dollar', symbol: 'S$', country: 'SG', flag: '🇸🇬', decimalDigits: 2 },
  { code: 'JPY', name: 'Japanese Yen', symbol: '¥', country: 'JP', flag: '🇯🇵', decimalDigits: 0 },
  { code: 'CHF', name: 'Swiss Franc', symbol: 'Fr', country: 'CH', flag: '🇨🇭', decimalDigits: 2 },
  { code: 'CNY', name: 'Chinese Yuan', symbol: '¥', country: 'CN', flag: '🇨🇳', decimalDigits: 2 },
  { code: 'HKD', name: 'Hong Kong Dollar', symbol: 'HK$', country: 'HK', flag: '🇭🇰', decimalDigits: 2 },
  { code: 'NZD', name: 'New Zealand Dollar', symbol: 'NZ$', country: 'NZ', flag: '🇳🇿', decimalDigits: 2 },
  { code: 'SEK', name: 'Swedish Krona', symbol: 'kr', country: 'SE', flag: '🇸🇪', decimalDigits: 2 },
  { code: 'NOK', name: 'Norwegian Krone', symbol: 'kr', country: 'NO', flag: '🇳🇴', decimalDigits: 2 },
  { code: 'DKK', name: 'Danish Krone', symbol: 'kr', country: 'DK', flag: '🇩🇰', decimalDigits: 2 },
  { code: 'KRW', name: 'South Korean Won', symbol: '₩', country: 'KR', flag: '🇰🇷', decimalDigits: 0 },
  { code: 'MXN', name: 'Mexican Peso', symbol: 'Mex$', country: 'MX', flag: '🇲🇽', decimalDigits: 2 },
  { code: 'BRL', name: 'Brazilian Real', symbol: 'R$', country: 'BR', flag: '🇧🇷', decimalDigits: 2 },
  { code: 'ZAR', name: 'South African Rand', symbol: 'R', country: 'ZA', flag: '🇿🇦', decimalDigits: 2 },
  { code: 'BHD', name: 'Bahraini Dinar', symbol: 'BD', country: 'BH', flag: '🇧🇭', decimalDigits: 3 },
  { code: 'KWD', name: 'Kuwaiti Dinar', symbol: 'KD', country: 'KW', flag: '🇰🇼', decimalDigits: 3 },
];
